import type { Location } from "react-router-dom";

export type URLParams = {
  mailMagId: string | null;
  transitionSource: string | null;
  returnTo: string | null;
  authorizationCode: string | null;
  error: string | null;
  errorDescription: string | null;
  surveyId: string | null;
  signUp: string | null;
  bulkDownload: string | null;
}
export const useUrlParams = (searchParam: string) => {
  const urlParams = new URLSearchParams(searchParam);

  const mailMagId = urlParams.get("mailmagid");
  const transitionSource = urlParams.get("transition_source");
  const returnTo = urlParams.get("returnto");
  // Authorization Code Flowのcode
  const authorizationCode = urlParams.get("code");
  const error = urlParams.get("error");
  const errorDescription = urlParams.get("error_description");
  const surveyId = urlParams.get("survey_id");
  const signUp = urlParams.get("signup");
  const bulkDownload = urlParams.get("bulkDownload");

  const getUrlParams = (): URLParams => {
    return {
      mailMagId,
      returnTo,
      transitionSource,
      authorizationCode,
      error,
      errorDescription,
      surveyId,
      signUp,
      bulkDownload,
    }
  }

  return {
    getUrlParams 
  };
};
